import NumberFormat from 'react-number-format';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Label = styled.label`
  color: ${(props) => props.theme.textDark};
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const InputBox = styled.div`
  border: 1px solid ${(props) => props.theme.keyline};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 56px;
  padding: 0 15px;
`;

export const Prefix = styled.p`
  font-size: 16px;
  color: ${(props) => props.theme.textLight};
`;

export const Input = styled(NumberFormat)`
  color: ${(props) => props.theme.textDark};
  font-size: 16px;
  border: none;
  padding: 0;
  flex: 1;
  min-width: 0;
  width: 100%;
`;
